import { useTranslation } from "next-i18next";
import Image from "next/image";

const FastInstallationAnd247TechnicalSupport = () => {
    const { t } = useTranslation(["common", "homepage", "email"]);

    return (
        <div className="py-10 bg-makdosSecondaryGray">
            <div className="container mx-auto">
                <div>
                    <h2 className="relative z-10 px-2 text-3xl font-semibold text-center text-titleColor lg:px-0 lg:text-4xl text-after-shadow-email4">{t("email:fastInstallationAnd247TechnicalSupport")}</h2>
                </div>

                <div className="flex flex-col items-center px-2 mt-8 lg:flex-row lg:px-0">
                    <div className="p-4 bg-white border-4 border-makdosYellow w-full lg:w-[297px] h-[380px] lg:h-[600px]">
                        <div>
                            <h3 className="pb-2 text-2xl font-semibold text-titleColor">{t("email:quickAndEasyInstallationProcess")}</h3>
                            <div className="pb-6 text-sm text-textGray lg:text-base" dangerouslySetInnerHTML={{ __html: t("email:quickAndEasyInstallationProcessDesc") }}></div>
                        </div>
                        <div className="pb-6">
                            <h4 className="font-bold text-titleColor">{t("email:userFriendlyPanel")}</h4>
                            <p className="text-sm text-textGray lg:text-base">{t("email:userFriendlyPanelDesc")}</p>
                        </div>
                        <div className="pb-6">
                            <h4 className="font-bold text-titleColor">{t("email:quickActivation")}</h4>
                            <div className="text-sm text-textGray lg:text-base" dangerouslySetInnerHTML={{ __html: t("email:quickActivationDesc") }}></div>
                        </div>

                        <div className="pb-6">
                            <h4 className="font-bold text-titleColor">{t("email:guidedInstallationSupport")}</h4>
                            <p className="text-sm text-textGray lg:text-base">{t("email:guidedInstallationSupportDesc")}</p>
                        </div>
                    </div>
                    <div className="pt-4 lg:pt-0">
                        <Image src={"/fastInstallation247TechnicalSupport.png"} width={617} height={600} alt={t("email:fastInstallationAnd247TechnicalSupport")} title={t("email:fastInstallationAnd247TechnicalSupport")} />
                    </div>
                    <div className="p-4 bg-white border-4 border-makdosYellow w-full lg:w-[297px] h-[480px] lg:h-[600px]">
                        <div className="pb-6 space-y-2">
                            <h3 className="text-2xl font-semibold text-titleColor">{t("email:247TechnicalSupportTeam")}</h3>
                            <p className="text-sm text-textGray lg:text-base">{t("email:247TechnicalSupportTeamDesc")}</p>
                        </div>
                        <div className="pb-6">
                            <h4 className="font-bold text-titleColor">{t("email:quickSolution")}:</h4>
                            <p className="text-sm text-textGray lg:text-base">{t("email:quickSolutionDesc")}</p>
                        </div>

                        <div className="pb-6">
                            <h4 className="font-bold text-titleColor">{t("email:variousSupportChannels")}:</h4>
                            <div className="text-sm text-textGray lg:text-base" dangerouslySetInnerHTML={{ __html: t("email:variousSupportChannelsDesc") }}></div>
                        </div>

                        <div className="pb-6">
                            <h4 className="font-bold text-titleColor">{t("email:proactiveSupport")}:</h4>
                            <div className="text-sm text-textGray lg:text-base" dangerouslySetInnerHTML={{ __html: t("email:proactiveSupportDesc") }}></div>
                        </div>

                        <div className="pb-2 ">
                            <h4 className="font-bold text-titleColor">{t("email:expertStaff")}:</h4>
                            <p className="text-sm text-textGray lg:text-base">{t("email:expertStaffDesc")}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FastInstallationAnd247TechnicalSupport